import axios from 'axios';

// Configuration de l'URL de base de l'API
const rawApiUrl = (process.env.REACT_APP_API_URL || '').trim();
const normalizedApiUrl = rawApiUrl.replace(/^['\"]+|['\"]+$/g, '');

export const API_BASE_URL = normalizedApiUrl || "https://back.gs7solutions.com";

// Créer une instance axios configurée
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000, // Timeout de 10 secondes
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur de requête
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error('Erreur lors de la préparation de la requête:', error);
    return Promise.reject(error);
  }
);

// Intercepteur de réponse pour gérer les erreurs globalement
apiClient.interceptors.response.use(
  (response) => {
    // Retourner la réponse si tout va bien
    return response;
  },
  (error) => {
    // Gérer les différents types d'erreurs
    if (error.code === 'ECONNABORTED') {
      console.error('La requête a expiré. Le serveur met trop de temps à répondre.');
      error.userMessage = 'La requête a expiré. Veuillez réessayer.';
    } else if (error.code === 'ERR_NETWORK' || !error.response) {
      console.error('Erreur réseau: Le serveur est probablement hors ligne.');
      error.userMessage = 'Impossible de joindre le serveur. Veuillez vérifier votre connexion ou réessayer plus tard.';
    } else if (error.response) {
      // Le serveur a répondu avec un code d'erreur
      const status = error.response.status;
      
      switch (status) {
        case 400:
          error.userMessage = 'Requête invalide. Veuillez vérifier vos données.';
          break;
        case 401:
          error.userMessage = 'Non autorisé. Veuillez vous connecter.';
          break;
        case 403:
          error.userMessage = 'Accès refusé.';
          break;
        case 404:
          error.userMessage = 'Ressource non trouvée.';
          break;
        case 500:
          error.userMessage = 'Erreur serveur. Veuillez réessayer plus tard.';
          break;
        default:
          error.userMessage = `Erreur: ${error.response.data?.error || 'Une erreur est survenue'}`;
      }
      
      console.error(`Erreur ${status}:`, error.response.data);
    }
    
    return Promise.reject(error);
  }
);

// Export du client configuré et de l'URL de base
export { apiClient };
export default API_BASE_URL;

